/**
 * @desc 禁用和启用
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stagingAreaMaster.updateStatus.Params, options?: any) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/updateStatus`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
